
<div class="content-step">
    <div class="affiliate-info">
      <div class="container">
        <div class="logo-grupo">
            <div  *ngIf="flag === 'colombia'">
              <img src="../../../../assets/img/Mask_group.svg"  alt="" srcset="">
            </div>
            <div *ngIf="flag === 'uruguay'">
              <img src="../../../../assets/img/Mask_group_ucm.svg"  alt="" srcset="">
            </div>
        </div>
        <div class="text-top">
          <h2>Aquí podrás pagar tus facturas</h2>
          <div class="text-descrip text-center">
            <p class="text-descript">Elige la factura que deseas pagar y selecciona
              el medio de pago que prefieras.</p>
            <p class="text-descript">una vez realices el pago recibirás el
              comprobante.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <form class="form-element" [formGroup]="paymentMethodForm"
        (ngSubmit)="onSubmit()">
        <div id="stepper1" class="bs-stepper">
          <div class="bs-stepper-header stepper-labels">
            <div class="step" data-target="#test-l-1" (click)="resetStepperOne()">
              <button class="step-trigger"  [disabled]="!showOne" #stepperOne>
                <span class="bs-stepper-circle" *ngIf="!showCheckOne">1</span>
                <span class="bs-stepper-circle" *ngIf="showCheckOne"><i class="fa fa-check"></i></span>
                <span class="bs-stepper-label sub-title-step">Buscar factura</span>
              </button>
            </div>
            <div class="line"></div>
            <div class="step" data-target="#test-l-2" (click)="resetStepperTwo()" >
              <button class="step-trigger" [disabled]="!showCheckOne" #stepperTwo>
                <span class="bs-stepper-circle" *ngIf="!showCheckTwo">2</span>
                <span class="bs-stepper-circle" *ngIf="showCheckTwo"><i class="fa fa-check"></i></span>
                <span class="bs-stepper-label sub-title-step">Seleccionar facturas</span>
              </button>
            </div>
            <div class="line"></div>
            <div class="step" data-target="#test-l-3" (click)="resetStepperThree()">
              <button class="step-trigger"   [disabled]="!showCheckTwo">
                <span class="bs-stepper-circle" *ngIf="!showCheckThree">3</span>
                <span class="bs-stepper-circle" *ngIf="showCheckThree"><i class="fa fa-check"></i></span>
                <span class="bs-stepper-label sub-title-step">Resumen de pago</span>
              </button>
            </div>
            <div class="line"></div>
            <div class="step" data-target="#test-l-4" (click)="resetStepperFour()">
              <button class="step-trigger"   [disabled]="!showCheckThree" #stepperFour>
                <span class="bs-stepper-circle">4</span>
                <span class="bs-stepper-label sub-title-step">Comprobante de pago</span>
              </button>
            </div>
          </div>
          <div class="bs-stepper-content">
            <div id="test-l-1" class="content">
              <div class="content-items">
                <div class="content-panel">
                  <div class="row">
                    <div class="col-sm text-center text-top top">
                      <h3 class="subtitle">Buscar factura</h3>
                      <p class="text-descript">Diligencia tu tipo de documento y
                        número de documento para buscar tus facturas.</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm">
                      <div class="group">
                        <select formControlName="TipoDocumento">
                          <option [value]="typeDoc.codigo" *ngFor="let typeDoc of
                            typeDocument">
                            {{typeDoc.nombre}}
                          </option>
                        </select>
                        <span class="text-danger span-error"
                          *ngIf="paymentMethodForm.get('TipoDocumento')?.errors?.['required']
                          &&
                          ( paymentMethodForm.get('TipoDocumento')?.touched)">
                          {{ 'El tipo documento son obligatorio'}}
                        </span>
                       
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label-title">Tipo documento <span
                            class="text-danger">*</span></label>
                      </div>
                    </div>
                    <div class="col-sm">
                      <div class="group">
                        <input type="text" required="required"
                          formControlName="Documento" pattern="[0-9]{1,20}"
                          (change)="resetFormData()"/>
                        <span class="text-danger span-error"
                          *ngIf="paymentMethodForm.get('Documento')?.errors?.['required']
                          &&
                          ( paymentMethodForm.get('Documento')?.touched)">
                          {{ 'El Documento es obligatorio'}}
                        </span>
                        <span class="text-danger span-error" *ngIf="paymentMethodForm.get('Documento')?.hasError('pattern') &&
                                                                  ( paymentMethodForm.get('Documento')?.dirty || paymentMethodForm.get('Documento')?.touched)">
                          {{ 'El documento solo aceptan numeros' }}
                        </span>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label-title">Documento</label>
  
                      </div>
                    </div>
                  </div>
                  <div class="row mb-5">
                    <div class="col-sm text-center mb-4">
                      <div class="group">
                        <button class="class-btn-confirm" mat-raised-button
                          color="primary"
                          (click)="getDeudaDetalle()">Buscar</button>
                      </div>
                    </div>
                  </div>
                  <div  class="row mb-5 version">
                    <span> versión {{version}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div id="test-l-2" class="content">
              <div class="content-items">
                <div class="content-panel">
                  <div class="row">
                    <div class="col-sm text-center text-top top">
                      <h3 class="subtitle">Seleccionar recibo</h3>
                      <p class="text-descript">Selecciona el recibo que deseas pagar.</p>
                    </div>
                  </div>
                  <form [formGroup]="deudaDetalleForm">
                    <div class="table-responsive table-material">
                      <table class="table">
                        <thead class="head-table">
                          <tr>
                            <th scope="col"></th>
                            <th scope="col">Referencia</th>
                            <th scope="col">Fecha vencimiento</th>
                            <th scope="col">Descripción</th>
                            <th scope="col">Subtotal</th>
                            <th scope="col">Valor a pagar</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let deuda of DeudasArray.controls; let i=index" [formGroup]="getFormDeuda(deuda)">
                          <td>
                            <input class="form-check-input mt-2 check-tab" type="checkbox" value="{{deuda.get('selected')?.value}}"
                              id="flexCheckChecked" formControlName="selected"
                              (change)="changeSelected()">
                          </td>
                          <td scope="row">
                            {{deuda.get('numero')?.value}}
                          </td>
                          <td>
                            {{ deuda.get('descripcionFactura')?.value }} 
                          </td>
                          <td scope="row">
                            {{ deuda.get('estado')?.value === 'NP' ? 'Disponible para pago': '' }}
                          </td>
                          <td>
                            {{ deuda.get('saldoFactura')?.value | currency:'$':'symbol':'1.0-0' }}
                          </td>
                          <td scope="row">
                            {{ deuda.get('saldoFactura')?.value | currency:'$':'symbol':'1.0-0' }}
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td scope="row"></td>
                          <td></td>
                          <td scope="row"></td>
                          <td>
                            <strong>Total a pagar:</strong>
                          </td>
                          <td scope="row">
                            <strong>{{saldoTotalAcumulado | currency:'$':'symbol':'1.0-0'}}</strong>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="btn-content">
                      <button class="class-btn-confirm" mat-raised-button
                        color="primary"
                        (click)="receiptsSelected()" >Continuar</button>
                    </div>
                    <div class="row mb-5 mt-5 version">
                      <span> versión {{version}}</span>
                    </div>
                    <br>
                    <br>
                  </form>
                </div>
              </div>
            </div>
            <div id="test-l-3" class="content">
              <div class="content-items">
                <div class="content-panel">
                  <div class="row">
                    <div class="col-sm text-center text-top top">
                      <h3 class="subtitle">Resumen de pago</h3>
                    </div>
                  </div>
                  <form [formGroup]="deudaDetalleForm">
                    <table class="table-material mt-4">
                      <thead class="head-table">
                        <tr>
                          <th scope="col">Referencia</th>
                          <th scope="col">Descripción</th>
                          <th scope="col">Valor a pagar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let deuda of facturaSelected; let i=index">
                          <td scope="row">
                            {{deuda.numero}}
                          </td>
                          <td scope="row">
                            {{ deuda.estado === 'NP' ? 'Disponible para pago': '' }}
                          </td>
                          <td scope="row">
                            {{ deuda.saldoFactura | currency:'$':'symbol':'1.0-0' }}
                          </td>
                        </tr>
                        <tr>
                          <td scope="row"></td>
                          <td>
                            <strong>Total a pagar:</strong>
                          </td>
                          <td scope="row">
                            <strong>{{saldoTotalSelected | currency:'$':'symbol':'1.0-0'}}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="btn-content">
                      <button class="class-btn-confirm" mat-raised-button
                        color="primary"
                        (click)="PagarMercadoPago()" [disabled]="enableButtonPay" >Pagar</button>
                    </div>
                    <br>
                    <br>
                  </form>
                </div>
              </div>
            </div>
            <div id="test-l-4" class="content text-center">
              <div class="tab-content" id="voucher" #vocuher >
              
                <div class="col-sm text-center text-top-small top">
                  <div class="row">
                    <img src="../../../../assets/img/check.svg" alt="" srcset="">
                  </div>
                  <h2 class="subtitle">¡ Tu págo fue exitoso !</h2>
                  <p class="text-descript"><strong> Tu transacción en {{company}} por un valor de {{money}} {{infoPreference?.items[0].unit_price | currency:'$ ':'symbol':'1.0-0'}}
                    ha sido APROBADA </strong></p>
                </div>
                <div class="content-complet-pay" >
                  <div class="content-information-user border-bottom">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-md-4 d-grid border-end">
                          <span class="title-confi">Nombre Completo</span>
                          <span class="value-confi"> {{ infoPreference?.payer?.name}}</span>
                        </div>
                        <div class="col-md-4 d-grid border-end">
                          <span class="title-confi">Tipo de documento</span>
                          <container [ngSwitch]="infoPreference?.payer?.identification?.type">
                            <!-- the same view can be shown in more than one case -->
                            <span class="value-confi" *ngSwitchCase="'CC'">
                              {{'Cédula de ciudadanía '}}
                            </span>
                            <span class="value-confi" *ngSwitchCase="'CI'">
                              {{'Cédula de identidad '}}
                            </span>
                          </container>
                        </div>
                        <div class="col-md-4 d-grid ">
                          <span class="title-confi">Número de documento</span>
                      <span class="value-confi">{{ infoPreference?.payer?.identification?.number }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content-information">
                    <div class="content-titles">
                      <div class="content-info-pay">
                        <label>Estado:       <span class="span-pay">{{ infoPreference?.auto_return === 'approved' ? 'Aprobado': 'Rechazado'}}</span>  </label>
                        <label>Fecha:        <span class="span-pay">{{ infoPreference?.date_created |  date: 'medium' }}</span>  </label>
                        <label>Referencia:   <span class="span-pay">{{ infoPreference?.collector_id}}</span>  </label>
                        <label>Valor:        <span class="span-pay">{{ infoPreference?.items[0]?.unit_price | currency:'$ ':'symbol':'1.0-0'}}</span>  </label>
                        <label>Descripción:  <span class="span-pay">{{ infoPreference?.items[0]?.description}}</span>  </label>
                        <label>Autorización: <span class="span-pay">{{ 'Grupo EMI'}}</span>  </label>
  
                      </div>
                      
                    </div>
                  
                  </div>
                  <div class="content-information-btn d-flex">
                    <div class="btn-content">
                      <button class="class-btn-confirm" mat-raised-button
                        color="primary"
                        (click)="gotToHome()" >Pagar otra factura</button>
                  
                      <button class="class-btn-confirm" mat-raised-button
                        color="primary"
                        (click)="PrintVoucher()">Imprimir</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

<app-loading [isLoading]="isLoading"></app-loading>
<!-- <app-modal-mercado [urlMercadoPago]="urlMercadoPago" [activeModal]="activeModal"></app-modal-mercado>  -->
<button type="button" #openMercadoPago class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal" [hidden]="true"></button>
  
<div class="modal fade" id="exampleModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-body">
        <iframe width="100%" height="650px" [src]="urlMercadoPago | sanitizeUrl"></iframe>
      </div>
      <div class="modal-footer border-0" >
        <button class="class-btn-confirm" mat-raised-button color="primary" data-bs-dismiss="modal">Cancelar</button>
      </div>
    </div>
    
  </div>
</div> 